export const globalGtm = {
  execed: "GTM-WLWLFTM",
};
